<template>
    <div class="colorarray">
        <div class="color"
             v-for="color in colors"
             :style="{'background-color': color.color}"
             :key="color.color"
             :class="{'selected': selected && selected.color === color.color}"
             @click="colorClickHandler(color)"
             :title="color.name">
        </div>
    </div>
</template>

<script>
    import Attribute        from "../../../expivi/attributes/Attribute"
    import ValuableMaterial from "../../../expivi/attributes/ValuableMaterial"

    export default {
        name:    "ColorSelector",
        props:   {
            attribute: {
                required: true,
                type:     Attribute
            },
            selected:  {
                required: true,
            },
            material:  {
                required: false,
                type:     ValuableMaterial,
                default:  function () {
                    return null
                }
            }
        },
        data:    function () {
            return {
                colors:         [],
                attributeValue: null
            }
        },
        mounted: function () {
            if (this.attribute.hasAttributeValues()) {
                this.attributeValue = this.attribute.getAttributeValues()[0]
                this.colors = this.attributeValue.getColorOptions()
                this.loadDefaultColor()
            }
        },
        methods: {
            /**
             * Load the default color for the given Attribute. This seems not to work correctly with preconfigured
             * products.
             *
             * TODO: Check back with expivi what to do regarding the preconfigured products.
             * This might lead to problems, if you would like to load an existing product.
             */
            loadDefaultColor: function () {
                let valuable = this.attributeValue.getAttributeValueValuable()
                let materialId = valuable.material_id

                if (this.material !== null && materialId === null) {
                    materialId = this.material.getId()
                }

                if (materialId !== null) {
                    this.$expiviReady.then(expivi => {
                        // Resolve the Material Manager which we need to load materials
                        expivi.managers.resolveMaterialManager()
                            .then(materialManager => {
                                // Load the material where the color should be applied to
                                materialManager.resolveMaterialById(materialId, resolvedMaterial => {
                                    // Check if the now resolved material has a color assigned
                                    if (resolvedMaterial !== null && resolvedMaterial.color !== null) {
                                        // From the color options that we collected before, select the correct color Object
                                        let selectedColor = this.colors.filter(value => {
                                            // Make the default color comparable, because we're working with THREE.js colors
                                            let color = new THREE.Color()
                                            color.setStyle(value.color.substring(0, 7))
                                            return color.getHexString() === resolvedMaterial.color.getHexString()
                                        })

                                        // If the selected color could not be resolved, fallback to black by default.
                                        if (selectedColor.length === 0) {
                                            console.log('Could not resolve default color. Fallback to manual selection of black.', resolvedMaterial.color.getHexString())
                                            selectedColor = this.colors.filter(value => {
                                                return value.color === '#000000ff'
                                            })
                                        }

                                        // Set the color attribute in expivi
                                        expivi.setProductAttribute(this.attribute.getId(), selectedColor[0].color)

                                        // Emit the selected color event to the parent component to update its store accordingly
                                        this.$emit('selected:color', selectedColor[0])
                                    }
                                })

                            })
                    })
                } else {
                    console.log('Info: No Material set for the color attribute')
                    let selectedColor = this.colors.filter(value => {
                        return value.color === '#000000ff'
                    })

                    this.$expiviReady.then(expivi => expivi.setProductAttribute(this.attribute.getId(), selectedColor[0].color))
                    this.$emit('selected:color', selectedColor[0])
                }
            },

            /**
             * Emits the selected:color event, when a color has been clicked.
             * It is emitted to make sure that the parent component handles to update of the store property accordingly.
             *
             * @param color
             */
            colorClickHandler: function (color) {
                this.$expiviReady.then(expivi => {
                    expivi.setProductAttribute(this.attribute.getId(), color.color)
                    this.$emit('selected:color', color)
                })
            },
        }
    }
</script>

<style scoped>

</style>
